<h2 mat-dialog-title>Rescale in All Frames</h2>

<mat-dialog-content>
  This will resize the cuboid in all frames to match its size in the current
  frame.
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="primary">Cancel</button>
  <button mat-button [mat-dialog-close]="true" color="primary">
    Rescale All
  </button>
</mat-dialog-actions>
